import { computed, MaybeRef, toRef } from "vue";
import { route } from "ziggy-js";

export default function useParams(params?: MaybeRef<Record<string, string>>) {
  const _params = toRef(params || route().params);

  /**
   * Checks if the value is numeric.
   *
   * @param value
   */
  const isNumeric = (value: unknown): boolean =>
    typeof value === "number" ||
    (typeof value === "string" && value.trim() !== "" && !isNaN(Number(value)));

  /**
   * Normalized params, where all values are converted to their appropriate types.
   */
  return computed<Record<string, string | number | boolean>>(() => {
    return Object.fromEntries(
      Object.entries(_params.value).map(([key, value]) => {
        if (value === "true") {
          return [key, true];
        } else if (value === "false") {
          return [key, false];
        } else if (isNumeric(value)) {
          return [key, Number(value)];
        } else {
          return [key, value];
        }
      }),
    );
  });
}
